import { StringField, LinkField, DropdownSelect, FooterLink, FooterLinkFields } from '../../types/types';

export class FooterLinkModel {
  private readonly fields?: FooterLinkFields;
  constructor(props: FooterLink) {
    this.fields = props.fields;
  }

  get link(): LinkField | undefined {
    return this.fields?.link;
  }

  get linkUrl(): string {
    return this.link?.value?.href || '';
  }

  get hasLink(): boolean {
    return !(!this.linkUrl || (this.linkUrl === 'http://' && this.linkText));
  }

  get linkText(): string {
    return this.link?.value?.text || '';
  }

  get list(): FooterLink[] {
    return this.fields?.list && Array.isArray(this.fields?.list) ? this.fields.list : [];
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get type(): DropdownSelect | undefined {
    return this.fields?.type;
  }
}
